// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__2NjaX","action-wrapper":"Popper_action-wrapper__3o6M8"};